import z from "zod";
import { looseUuid } from "@thalamos/common";
export const DataSharingPartnershipIdSchema = looseUuid().brand();
export const DataSharingPartnershipSchema = z
    .object({
    id: DataSharingPartnershipIdSchema,
    name: z.string().min(1).max(255),
})
    .brand();
export const DataSharingPartnershipWithDataControllersSchema = z
    .object({
    id: DataSharingPartnershipIdSchema,
    name: z.string().min(1).max(255),
    dataControllers: z.array(z.object({ id: z.uuid(), name: z.string() })),
})
    .brand();
//# sourceMappingURL=dataSharingPartnership.js.map